import { ButtonFloatingComponent } from './button-floating.component';

export default angular
  .module('sfMobile.components.button-floating', [])
  .component('sfButtonFloating', ButtonFloatingComponent).name;
